module.exports = __webpack_public_path__ + "media/images/active_material/icons/email-6b2f1dde383932ebc73f9483039f27d2.svg";